export default __webpack_public_path__ + "static/media/Panda.6570acbf.png";